import { RuleTableResponse } from "types/table";

export enum ImportConflictAction {
  Abort = "ABORT",
  NewFamily = "NEW_FAMILY",
  NewVersion = "NEW_VERSION",
  Replace = "REPLACE",
}

export enum ImportTsvAction {
  Create = "CREATE",
  Replace = "REPLACE",
}

export type ImportTsvMatchBy = "ID" | "COMPARE ID";

export interface ImportTsvMatch {
  isReplaceCandidate: boolean;
  matchBy?: ImportTsvMatchBy | null;
  tableId?: string | null;
  compareId?: string | null;
  tableType?: string | null;
  table?: RuleTableResponse | null;
}

export interface MacroResponse {
  failures: string[];
  log: string[];
  summaryMessage: string;
}
